const STORAGE_KEY = "seexr-device-id";
const COOKIE_NAME = "seexr_device_id";
const DEVICE_ID_PATTERN = /^[A-Za-z0-9._:-]{16,128}$/;

function cookieDeviceId(): string | null {
  if (typeof document === "undefined") return null;
  const value = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${COOKIE_NAME}=`))
    ?.slice(COOKIE_NAME.length + 1);
  return value && DEVICE_ID_PATTERN.test(value) ? value : null;
}

export function getDeviceId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const fromCookie = cookieDeviceId();
  if (fromCookie) {
    window.localStorage.setItem(STORAGE_KEY, fromCookie);
    return fromCookie;
  }

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && DEVICE_ID_PATTERN.test(stored)) return stored;

  const generated =
    typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${crypto.getRandomValues(new Uint32Array(4)).join("-")}`;
  window.localStorage.setItem(STORAGE_KEY, generated);
  return generated;
}

export function withDeviceHeader(headers?: HeadersInit): Headers {
  const output = new Headers(headers);
  const deviceId = getDeviceId();
  if (deviceId) output.set("X-SEEXR-Device-ID", deviceId);
  return output;
}
